// File: src/pages/business/CreateTestPage.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import UpgradeModal from '../../components/UpgradeModal';
const PLAN_FEATURES = {
    free: { ai: false, webcam: false, lockBrowser: false, limit: 1, name: 'STARTER' },
    pro: { ai: true, webcam: false, lockBrowser: true, limit: 10, name: 'PROFESSIONAL' },
    premium: { ai: true, webcam: true, lockBrowser: true, limit: 9999, name: 'ENTERPRISE' }
};

// --- ICONS & ASSETS ---
const ToggleSwitch = ({ checked, onChange, disabled }) => (
  <label style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1 }}>
    <input type="checkbox" style={{ position: 'absolute', width: 1, height: 1, opacity: 0 }} checked={checked} onChange={onChange} disabled={disabled} />
    <div style={{
      width: '44px', height: '24px', backgroundColor: checked ? '#2563EB' : '#E5E7EB',
      borderRadius: '99px', transition: 'all 0.2s', position: 'relative'
    }}>
      <div style={{
        position: 'absolute', top: '2px', left: '2px', width: '20px', height: '20px', backgroundColor: 'white',
        borderRadius: '50%', transition: 'all 0.2s', transform: checked ? 'translateX(20px)' : 'translateX(0)'
      }}></div>
    </div>
  </label>
);

const ToastNotification = ({ toasts, removeToast }) => {
  return (
    <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 10000, display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {toasts.map((toast) => (
        <div key={toast.id} className="animate-slideIn" style={{
          minWidth: '300px', padding: '16px', borderRadius: '8px',
          backgroundColor: toast.type === 'error' ? '#FEF2F2' : '#ECFDF5',
          borderLeft: toast.type === 'error' ? '4px solid #EF4444' : '4px solid #10B981',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', gap: '12px',
          animation: 'slideIn 0.3s ease-out'
        }}>
          <span className="material-symbols-outlined" style={{ color: toast.type === 'error' ? '#EF4444' : '#10B981' }}>
            {toast.type === 'error' ? 'error' : 'check_circle'}
          </span>
          <div>
            <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', color: '#1F2937' }}>{toast.title}</h4>
            <p style={{ margin: 0, fontSize: '13px', color: '#4B5563' }}>{toast.message}</p>
          </div>
          <button onClick={() => removeToast(toast.id)} style={{ marginLeft: 'auto', border: 'none', background: 'transparent', cursor: 'pointer', color: '#9CA3AF' }}>
            <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>close</span>
          </button>
        </div>
      ))}
      <style>{`@keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
    </div>
  );
};


// Hàm giải mã token lấy Plan (Đơn giản hóa)
const getUserPlan = () => {
    const token = localStorage.getItem('skillmatch_token');
    if (!token) return 'free';
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.user.plan || 'free'; // Giả sử token có trường plan, nếu không thì mặc định free
        // Lưu ý: Tốt nhất nên gọi API /me để lấy plan mới nhất nếu token cũ
    } catch (e) { return 'free'; }
};

// --- COMPONENT TOGGLE CÓ KHÓA (Logic UX mới) ---
const LockedToggle = ({ label, subLabel, checked, onChange, isLocked, onTriggerUpgrade }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', opacity: isLocked ? 0.6 : 1 }}>
        <div>
            <div style={{ fontSize: '14px', fontWeight: '500', color: '#111827', display: 'flex', alignItems: 'center', gap: '6px' }}>
                {label}
                {isLocked && <span className="material-symbols-outlined" style={{ fontSize: '14px', color: '#F59E0B' }}>lock</span>}
            </div>
            <div style={{ fontSize: '12px', color: '#6B7280' }}>{subLabel}</div>
        </div>
        <div onClick={() => isLocked ? onTriggerUpgrade() : onChange()} style={{cursor: isLocked ? 'not-allowed' : 'pointer'}}>
            <div style={{
                width: '44px', height: '24px', backgroundColor: isLocked ? '#E5E7EB' : (checked ? '#2563EB' : '#E5E7EB'),
                borderRadius: '99px', position: 'relative', transition: 'all 0.2s'
            }}>
                <div style={{
                    position: 'absolute', top: '2px', left: '2px', width: '20px', height: '20px', backgroundColor: 'white',
                    borderRadius: '50%', transition: 'all 0.2s', transform: checked ? 'translateX(20px)' : 'translateX(0)'
                }} />
            </div>
        </div>
    </div>
);
// Component Modal Upgrade (Nhúng vào cuối các file JSX bên dưới)


// --- COMPONENT MODAL AI ---
const AIGenerateModal = ({ isOpen, onClose, onGenerate, loading, currentType }) => {
  const [topic, setTopic] = useState('');
  const [count, setCount] = useState(10);
  const [difficulty, setDifficulty] = useState('Intermediate');
  const [language, setLanguage] = useState('vi');
  const [aiType, setAiType] = useState(currentType === 'practical' ? 'code' : 'mcq');

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!topic.trim()) return alert("Vui lòng nhập chủ đề!");
    // Truyền thêm aiType để hàm xử lý biết là gen code hay mcq
    onGenerate(topic, count, difficulty, aiType);
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 animate-fadeIn">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden transform transition-all animate-scaleUp">

        {/* Header Gradient */}
        <div className="bg-gradient-to-r from-indigo-600 to-blue-600 p-6 text-white flex justify-between items-start">
          <div>
            <h3 className="text-xl font-bold flex items-center gap-2">
              <span className="material-symbols-outlined text-yellow-300">auto_awesome</span>
              AI Generator Pro
            </h3>
            <p className="text-blue-100 text-sm mt-1">Tạo bộ câu hỏi chuyên sâu trong 30 giây</p>
          </div>
          <button onClick={onClose} className="text-white/80 hover:text-white hover:bg-white/20 p-1 rounded-full transition-colors">
            <span className="material-symbols-outlined text-2xl">close</span>
          </button>
        </div>

        <div className="p-6 space-y-5">
          {/* Input Topic */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Chủ đề / Vị trí tuyển dụng</label>
            <input
              type="text"
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all placeholder-gray-400"
              placeholder="VD: Senior ReactJS, Digital Marketing, Data Analyst..."
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-5">
            {/* Select Type */}
            <div>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#4B5563', marginBottom: '4px' }}>LOẠI CÂU HỎI</label>
              <select value={aiType} onChange={(e) => setAiType(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #D1D5DB', background: 'white' }}>
                <option value="mcq">Trắc nghiệm (MCQ)</option>
                <option value="code">Code / Thực hành</option>
                <option value="essay">Tự luận (Essay)</option>
              </select>
            </div>
            {/* Select Difficulty */}
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Trình độ (Difficulty)</label>
              <select
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none bg-white"
                value={difficulty}
                onChange={(e) => setDifficulty(e.target.value)}
              >
                <option value="Fresher">Fresher / Junior (Cơ bản)</option>
                <option value="Intermediate">Middle / Intermediate (Vừa)</option>
                <option value="Senior">Senior / Expert (Khó & Bẫy)</option>
              </select>
            </div>
          </div>

          {/* Select Language & Count */}
          <div className="grid grid-cols-2 gap-5">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Ngôn ngữ</label>
              <select
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none bg-white"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
              >
                <option value="vi">🇻🇳 Tiếng Việt</option>
                <option value="en">🇺🇸 English</option>
              </select>
            </div>
            <div>
              <div className="flex justify-between mb-2">
                <label className="text-sm font-bold text-gray-700">Số lượng</label>
                <span className="text-sm font-bold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-md">{count} câu</span>
              </div>
              <input
                type="range" min="1" max="30" step="1"
                className="custom-range"
                value={count}
                onChange={(e) => setCount(parseInt(e.target.value))}
              />
            </div>
          </div>

          {/* Hint Box */}
          <div className="bg-yellow-50 border border-yellow-100 p-3 rounded-xl flex gap-3 items-start">
            <span className="material-symbols-outlined text-yellow-600 text-lg mt-0.5">lightbulb</span>
            <p className="text-xs text-yellow-800 leading-relaxed">
              Mẹo: Chọn <strong>Code</strong> để AI tạo đề bài lập trình kèm Code mẫu.
            </p>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="p-6 pt-0 flex gap-3">
          <button onClick={onClose} className="flex-1 py-3 rounded-xl border border-gray-300 font-semibold text-gray-600 hover:bg-gray-50 transition-colors">
            Để sau
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="flex-1 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold shadow-lg hover:shadow-blue-500/30 hover:scale-[1.02] transition-all disabled:opacity-70 flex justify-center items-center gap-2"
          >
            {loading ? (
              <><span className="material-symbols-outlined animate-spin text-xl">sync</span> Đang tạo...</>
            ) : (
              <><span className="material-symbols-outlined text-xl">auto_awesome</span> Tạo ngay</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

// 3. Modal Xác nhận Xóa
const ConfirmDeleteModal = ({ onClose, onConfirm }) => {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 110 }}>
      <div style={{ background: 'white', padding: '24px', borderRadius: '12px', width: '320px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', textAlign: 'center' }}>
        <div style={{ width: '48px', height: '48px', background: '#FEE2E2', borderRadius: '50%', color: '#DC2626', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '28px' }}>delete</span>
        </div>
        <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Xóa câu hỏi?</h3>
        <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '24px' }}>Hành động này không thể hoàn tác.</p>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button onClick={onClose} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #D1D5DB', background: 'white', color: '#374151', fontWeight: '600', cursor: 'pointer' }}>Hủy</button>
          <button onClick={onConfirm} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: 'none', background: '#DC2626', color: 'white', fontWeight: '600', cursor: 'pointer' }}>Xóa</button>
        </div>
      </div>
    </div>
  );
};

// Helper: Format Date
const formatDateTimeLocal = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  const offset = date.getTimezoneOffset() * 60000;
  return (new Date(date - offset)).toISOString().slice(0, 16);
};

// --- MAIN COMPONENT ---
export default function CreateTestPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const [userPlan, setUserPlan] = useState('free');
  const [isLimitReached, setIsLimitReached] = useState(false); // ✅ Trạng thái chặn tạo mới
  const [currentTestCount, setCurrentTestCount] = useState(0); // Số bài test hiện tại

  // --- STATE ---
  const [assessmentName, setAssessmentName] = useState('Đánh giá năng lực mới');
  const [description, setDescription] = useState('');
  const [timeLimit, setTimeLimit] = useState(45);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [toasts, setToasts] = useState([]);
  const [currentPlan, setCurrentPlan] = useState('free'); 
  const [showUpgradeModal, setShowUpgradeModal] = useState({ show: false, msg: '' });
  const addToast = (title, message, type = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, title, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3000);
  };
  const [upgradeModal, setUpgradeModal] = useState({ show: false, message: '' });

  // State Security
  const [securitySettings, setSecuritySettings] = useState({
    enableAI: false, enableWebcam: false, enableScreen: false, lockBrowser: false,
    webcamInterval: 2, maxViolationLimit: 3
  });

  const [testType, setTestType] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [parsedQuestions, setParsedQuestions] = useState([]);
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isPublic, setIsPublic] = useState(false);

  // --- STATE AI & MODAL ---
  const [showAIModal, setShowAIModal] = useState(false);
  const [isAILoading, setIsAILoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);

  const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

  // Load data khi edit
  useEffect(() => {
    const token = localStorage.getItem('skillmatch_token');
    if (!token) return;

    const fetchData = async () => {
        try {
            // 1. Lấy thông tin gói cước
            const meRes = await fetch(`${API_URL}/api/auth/me`, { headers: { 'x-auth-token': token } });
            const meData = await meRes.json();
            const plan = meData.subscription?.plan || 'free';
            setUserPlan(plan);

            // 2. Lấy danh sách bài test để đếm
            const testsRes = await fetch(`${API_URL}/api/tests/my-tests`, { headers: { 'x-auth-token': token } });
            const testsData = await testsRes.json();
            const count = testsData.length || 0;
            setCurrentTestCount(count);

            // 3. Kiểm tra giới hạn (Chỉ chặn nếu là TẠO MỚI)
            const limit = PLAN_FEATURES[plan]?.limit || 1;
            if (!isEditMode && count >= limit) {
                setIsLimitReached(true);
            }

        } catch (e) { console.error("Init Error:", e); }
    };
    fetchData();
    if (isEditMode) {
      const fetchTestData = async () => {
        try {
          const token = localStorage.getItem('skillmatch_token');
          const response = await fetch(`${API_URL}/api/tests/${id}`, {
            headers: { 'x-auth-token': token }
          });
          const data = await response.json();
          if (response.ok) {
            setAssessmentName(data.assessmentName);
            setTimeLimit(data.timeLimit);
            setTestType(data.testType);
            setParsedQuestions(data.questions);
            setDescription(data.description || '');
            if (data.securitySettings) setSecuritySettings(data.securitySettings);
            if (data.startDate) setStartDate(formatDateTimeLocal(data.startDate));
            if (data.endDate) setEndDate(formatDateTimeLocal(data.endDate));
            setIsPublic(data.isPublic || false);
          }
        } catch (error) {
          console.error("Lỗi load test:", error);
        }
      };
      fetchTestData();
    }
  }, [id, isEditMode, API_URL]);
  const triggerUpgrade = (featureName, reqPlan) => {
      setUpgradeModal({
          show: true,
          message: `Tính năng "${featureName}" chỉ dành cho gói ${reqPlan}. Vui lòng nâng cấp!`
      });
  };

  // Logic AI Button
  const handleAIButtonClick = () => {
      if (!PLAN_FEATURES[userPlan].ai) {
          triggerUpgrade("Tạo đề thi AI", "PROFESSIONAL");
          return;
      }
      setShowAIModal(true);
  };

  const handleSecurityChange = (key, value = null) => {
    if (value !== null) {
      setSecuritySettings(prev => ({ ...prev, [key]: value === '' ? '' : parseInt(value) }));
      return;
    }
    if (key === 'enableAI') {
      const newValue = !securitySettings.enableAI;
      setSecuritySettings(prev => ({
        ...prev, enableAI: newValue,
        enableWebcam: newValue ? prev.enableWebcam : false,
        enableScreen: newValue ? prev.enableScreen : false,
        lockBrowser: newValue ? prev.lockBrowser : false
      }));
    } else {
      setSecuritySettings(prev => ({ ...prev, [key]: !prev[key] }));
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) handleFileUpload(file);
  };
  const triggerFileInput = () => fileInputRef.current.click();

  const handleFileUpload = async (file) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('testType', testType || 'mcq');
    formData.append('testFile', file);
    const token = localStorage.getItem('skillmatch_token');
    try {
      const response = await fetch(`${API_URL}/api/tests/parse-upload`, {
        method: 'POST', body: formData, headers: { 'x-auth-token': token }
      });
      const parsedData = await response.json();
      if (!response.ok) throw new Error(parsedData.message || 'Lỗi từ máy chủ');

      setParsedQuestions(prev => [...prev, ...parsedData]);
      if (!testType) setTestType('mcq');
    } catch (error) {
      alert(`Lỗi: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ LOGIC XỬ LÝ DỮ LIỆU AI
  const handleAIGenerate = async (topic, count, difficulty, type) => {
    if (!topic.trim()) { addToast('Lỗi', 'Vui lòng nhập chủ đề!', 'error'); return; }

    setIsAILoading(true);
    const token = localStorage.getItem('skillmatch_token');

    try {
      const response = await fetch(`${API_URL}/api/tests/generate-ai`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
        body: JSON.stringify({ topic, quantity: count, difficulty, type })
      });
      const data = await response.json();
      if (response.status === 403 || data.requireUpgrade) {
          setShowAIModal(false); // Tắt modal AI
          setUpgradeModal({ show: true, message: data.message }); // Hiện modal Upgrade
          return;
      }

      let questionsArray = data.questions || [];
      if (!questionsArray.length) throw new Error("AI không trả về dữ liệu.");

      // Chuẩn hóa dữ liệu trả về
      const formattedQuestions = questionsArray.map(q => ({
        type: q.type || type, // Quan trọng: lấy type từ AI hoặc từ người dùng chọn
        question: q.question,
        options: q.options || [],
        correctAnswer: q.correctAnswer || 0,
        sampleCode: q.sampleCode || '', // Cho bài code
        solution: q.solution || '',     // Cho bài essay
        matchingPairs: [],
        mediaUrl: '',
        skill: topic
      }));

      setParsedQuestions(prev => [...prev, ...formattedQuestions]);
      setShowAIModal(false);
      // Nếu chưa chọn loại bài thì set theo loại vừa generate (ưu tiên type của câu hỏi đầu tiên)
      if (!testType) {
        const firstType = formattedQuestions[0].type;
        setTestType(firstType === 'code' ? 'practical' : 'mcq');
      }

      addToast('Thành công', `Đã tạo ${formattedQuestions.length} câu hỏi ${type}!`);

    } catch (error) {
      addToast('Lỗi AI', error.message, 'error');
    } finally {
      setIsAILoading(false);
    }
  };

  // --- QUESTION ACTIONS ---
  const updateQuestion = (index, field, value) => { const updatedQuestions = [...parsedQuestions]; updatedQuestions[index] = { ...updatedQuestions[index], [field]: value }; setParsedQuestions(updatedQuestions); };

  const requestDeleteQuestion = (index) => {
    setQuestionToDelete(index);
    setShowDeleteModal(true);
  };

  const confirmDeleteQuestion = () => {
    if (questionToDelete !== null) {
      const updatedQuestions = parsedQuestions.filter((_, i) => i !== questionToDelete);
      setParsedQuestions(updatedQuestions);
      setShowDeleteModal(false);
      setQuestionToDelete(null);
    }
  };

  const duplicateQuestion = (index) => {
    const newQuestions = [...parsedQuestions];
    const questionToCopy = JSON.parse(JSON.stringify(newQuestions[index]));
    newQuestions.splice(index + 1, 0, questionToCopy);
    setParsedQuestions(newQuestions);
  };

  // ✅ HÀM RENDER NỘI DUNG CÂU HỎI (QUAN TRỌNG)
  const renderQuestionContent = (q, idx) => {
    const updateQ = (field, val) => {
      const newQ = [...parsedQuestions];
      newQ[idx] = { ...newQ[idx], [field]: val };
      setParsedQuestions(newQ);
    };

    const autoResize = (e) => { e.target.style.height = 'auto'; e.target.style.height = e.target.scrollHeight + 'px'; };

    return (
      <div style={{ marginTop: '0px', width: '100%' }}>
        {/* Input Tiêu đề */}
        <textarea
          className="w-full border-none p-0 text-lg font-semibold text-[#111827] focus:ring-0 bg-transparent resize-none overflow-hidden leading-tight"
          rows={1} value={q.question || q.title}
          onChange={(e) => { updateQ('question', e.target.value); autoResize(e); }}
          onInput={autoResize}
          ref={(el) => el && (el.style.height = el.scrollHeight + 'px')}
          placeholder="Nhập nội dung câu hỏi..."
        />

        {/* Input Media (Ảnh/Audio) - Chỉ hiện khi hover hoặc có dữ liệu */}
        <div className="group/media" style={{ marginTop: '8px', marginBottom: '12px' }}>
          <div style={{ display: 'flex', gap: '8px', opacity: (q.mediaUrl || q.mediaType !== 'none') ? 1 : 0.4, transition: 'opacity 0.2s' }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = 1}>
            <input
              type="text"
              placeholder="Link ảnh/audio (URL)..."
              value={q.mediaUrl || ''}
              onChange={(e) => updateQ('mediaUrl', e.target.value)}
              // Sửa ở đây: Thêm color: '#111827' để ép màu chữ đen
              style={{
                flex: 1,
                padding: '6px 12px',
                fontSize: '13px',
                border: '1px solid #D1D5DB',
                borderRadius: '6px',
                background: '#FFFFFF', // Nền trắng
                color: '#111827',      // Chữ đen đậm
                outline: 'none'
              }}
            />
            <select
              value={q.mediaType || 'none'}
              onChange={(e) => updateQ('mediaType', e.target.value)}
              style={{ fontSize: '12px', border: '1px solid #E5E7EB', borderRadius: '4px', padding: '0 4px' }}
            >
              <option value="none">No Media</option>
              <option value="image">Image</option>
              <option value="audio">Audio</option>
            </select>
          </div>
          {q.mediaUrl && q.mediaType === 'image' && <img src={q.mediaUrl} alt="Preview" style={{ marginTop: '8px', maxHeight: '200px', borderRadius: '8px', border: '1px solid #E5E7EB' }} />}
        </div>

        {/* --- CASE 1: TRẮC NGHIỆM (MCQ) --- */}
        {(q.type === 'mcq' || !q.type) && (
          <div className="flex flex-col gap-2 mt-2">
            {(q.options || []).map((opt, optIdx) => (
              <div key={optIdx} onClick={() => updateQ('correctAnswer', optIdx)} className={`flex items-center gap-3 p-2 rounded-md border cursor-pointer ${optIdx === q.correctAnswer ? 'border-green-200 bg-green-50' : 'border-transparent hover:bg-gray-50'}`}>
                <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${optIdx === q.correctAnswer ? 'bg-green-500 border-green-500' : 'border-gray-300'}`}>
                  {optIdx === q.correctAnswer && <span className="material-symbols-outlined text-white text-[10px]">check</span>}
                </div>
                <input type="text" className="flex-1 bg-transparent border-none text-sm focus:ring-0" value={opt} onChange={(e) => {
                  const newOpts = [...q.options]; newOpts[optIdx] = e.target.value; updateQ('options', newOpts);
                }} />
              </div>
            ))}
          </div>
        )}

        {/* --- CASE 2: THỰC HÀNH CODE (CODE) --- */}
        {(q.type === 'code' || q.type === 'practical') && (
          <div style={{ marginTop: '16px' }}>
            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#6B7280', marginBottom: '4px' }}>CODE MẪU / BOILERPLATE (Cho ứng viên)</div>
            <textarea
              value={q.sampleCode || ''}
              onChange={(e) => updateQ('sampleCode', e.target.value)}
              style={{
                width: '100%',
                minHeight: '120px',
                fontFamily: 'monospace',
                fontSize: '13px',
                background: '#ffffff', // Nền tối
                color: '#000000',      // Chữ trắng sáng (để nổi trên nền tối)
                borderRadius: '8px',
                padding: '12px',
                border: 'none',
                resize: 'vertical'
              }}
              placeholder="// Nhập code mẫu để ứng viên bắt đầu..."
            />
          </div>
        )}

        {/* --- CASE 3: TỰ LUẬN (ESSAY) --- */}
        {q.type === 'essay' && (
          <div style={{ marginTop: '16px' }}>
            <div style={{ padding: '12px', background: '#F3F4F6', borderRadius: '8px', border: '1px dashed #D1D5DB', minHeight: '60px' }}>
              <p style={{ fontSize: '13px', color: '#9CA3AF', fontStyle: 'italic' }}>Khu vực trả lời của ứng viên (Văn bản tự do)</p>
            </div>
            <div style={{ marginTop: '8px' }}>
              <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#6B7280' }}>Gợi ý chấm điểm (Ẩn với ứng viên)</label>
              <textarea
                value={q.solution || ''}
                onChange={(e) => updateQ('solution', e.target.value)}
                style={{ width: '100%', marginTop: '4px', fontSize: '12px', border: '1px solid #E5E7EB', borderRadius: '6px', padding: '8px', minHeight: '60px' }}
                placeholder="Nhập các ý chính cần có trong câu trả lời..."
              />
            </div>
          </div>
        )}

        {/* --- CASE 4: NỐI (MATCHING) --- */}
        {q.type === 'matching' && (
          <div style={{ marginTop: '16px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '8px' }}>
              <div style={{ fontSize: '12px', fontWeight: 'bold' }}>Cột Trái (Câu hỏi)</div>
              <div style={{ fontSize: '12px', fontWeight: 'bold' }}>Cột Phải (Đáp án khớp)</div>
            </div>
            {(q.matchingPairs || []).map((pair, pIdx) => (
              <div key={pIdx} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: '12px', marginBottom: '8px' }}>
                <input type="text" value={pair.left} onChange={(e) => {
                  const newPairs = [...q.matchingPairs]; newPairs[pIdx].left = e.target.value; updateQ('matchingPairs', newPairs);
                }} className="border p-2 rounded text-sm" placeholder="Mục A" />
                <input type="text" value={pair.right} onChange={(e) => {
                  const newPairs = [...q.matchingPairs]; newPairs[pIdx].right = e.target.value; updateQ('matchingPairs', newPairs);
                }} className="border p-2 rounded text-sm" placeholder="Mục B tương ứng" />
                <button onClick={() => {
                  const newPairs = q.matchingPairs.filter((_, i) => i !== pIdx); updateQ('matchingPairs', newPairs);
                }} className="text-red-500 hover:bg-red-50 p-1 rounded"><span className="material-symbols-outlined text-[18px]">delete</span></button>
              </div>
            ))}
            <button onClick={() => {
              const newPairs = [...(q.matchingPairs || []), { left: '', right: '' }]; updateQ('matchingPairs', newPairs);
            }} style={{ fontSize: '12px', color: '#2563EB', fontWeight: '600', marginTop: '4px' }}>+ Thêm cặp nối</button>
          </div>
        )}
      </div>
    );
  };

  const addManualQuestion = (type = 'mcq') => {
    const template = {
      type: type,
      question: '',
      options: type === 'mcq' ? ['', '', '', ''] : [],
      correctAnswer: 0,
      matchingPairs: type === 'matching' ? [{ left: '', right: '' }, { left: '', right: '' }] : [],
      sampleCode: '',
      solution: '',
      skill: ''
    };
    setParsedQuestions(prev => [...prev, template]);
  };

  const handleDragStart = (e, index) => { setDraggedItemIndex(index); e.dataTransfer.effectAllowed = "move"; };
  const handleDragEnter = (e, index) => { e.preventDefault(); if (draggedItemIndex === null || draggedItemIndex === index) return; const newQuestions = [...parsedQuestions]; const draggedItem = newQuestions[draggedItemIndex]; newQuestions.splice(draggedItemIndex, 1); newQuestions.splice(index, 0, draggedItem); setDraggedItemIndex(index); setParsedQuestions(newQuestions); };
  const handleDragEnd = () => setDraggedItemIndex(null);
  const validateTest = () => {
    // 1. Validate Tên bài test
    if (!assessmentName || assessmentName.trim().length < 5) {
        alert("Tên bài kiểm tra quá ngắn (tối thiểu 5 ký tự)!");
        return false;
    }
    
    // Validate Thời gian
    if (parseInt(timeLimit) <= 0) {
        alert("Thời gian làm bài phải lớn hơn 0 phút!");
        return false;
    }

    // 2. Validate Số lượng câu hỏi
    if (parsedQuestions.length === 0) {
        alert("Bài kiểm tra phải có ít nhất 1 câu hỏi!");
        return false;
    }

    // 3. Validate Chi tiết từng câu hỏi
    for (let i = 0; i < parsedQuestions.length; i++) {
        const q = parsedQuestions[i];
        
        // Check độ dài câu hỏi
        const qContent = q.question || q.title || "";
        if (qContent.trim().length < 5) {
            alert(`Câu hỏi số ${i + 1} quá ngắn hoặc đang để trống!`);
            return false;
        }

        // Check trắc nghiệm (MCQ)
        if (q.type === 'mcq' || !q.type) {
            // Phải có ít nhất 2 đáp án & Đáp án không được rỗng
            const validOptions = q.options ? q.options.filter(opt => opt && opt.trim() !== "") : [];
            if (validOptions.length < 2) {
                alert(`Câu hỏi số ${i + 1} (Trắc nghiệm) cần ít nhất 2 đáp án hợp lệ!`);
                return false;
            }
            
            // Check chọn đáp án đúng
            if (q.correctAnswer === null || q.correctAnswer === undefined || q.correctAnswer >= q.options.length) {
                alert(`Vui lòng chọn đáp án đúng cho câu hỏi số ${i + 1}!`);
                return false;
            }
        }
        
        // Check Tự luận (Essay) - Phải có gợi ý chấm điểm (tùy chọn, nhưng nên có)
        if (q.type === 'essay' && (!q.solution || q.solution.trim().length < 5)) {
             // Có thể warning hoặc bắt buộc tùy logic của bạn. Ở đây mình chỉ warning nhẹ.
             // alert(`Câu hỏi số ${i + 1} (Tự luận) nên có gợi ý chấm điểm!`);
        }
    }

    return true;
  };

  const handleSave = async (status) => {
    if (!validateTest()) return;
      // Chặn ngay ở Client nếu đã đạt giới hạn (UX)
      if (isLimitReached && !isEditMode) {
          setUpgradeModal({ 
              show: true, 
              message: `Bạn đã đạt giới hạn ${PLAN_FEATURES[userPlan].limit} bài test của gói ${PLAN_FEATURES[userPlan].name}.` 
          });
          return;
      }

      if (!assessmentName || parsedQuestions.length === 0) { alert('Vui lòng nhập tên và câu hỏi!'); return; }
      setIsSaving(true);
      const token = localStorage.getItem('skillmatch_token');
      
      const testData = { assessmentName, description, timeLimit: parseInt(timeLimit, 10), securitySettings, testType, questions: parsedQuestions, isPublic, status };

      try {
        const url = isEditMode ? `${API_URL}/api/tests/${id}` : `${API_URL}/api/tests/create`;
        const method = isEditMode ? 'PUT' : 'POST';
        const response = await fetch(url, { method, headers: { 'Content-Type': 'application/json', 'x-auth-token': token }, body: JSON.stringify(testData) });
        const data = await response.json();
        
        // Bắt lỗi từ Backend trả về
        if (response.status === 403 || data.requireUpgrade) {
            setUpgradeModal({ show: true, message: data.message });
            return;
        }
        if (!response.ok) throw new Error(data.message || 'Lỗi lưu bài test');
        
        navigate('/business/tests', { state: { successMessage: isEditMode ? 'Cập nhật thành công!' : 'Tạo mới thành công!' } });
      } catch (error) { alert('Lỗi: ' + error.message); } finally { setIsSaving(false); }
  };

  return (
    <div style={{ backgroundColor: '#F9FAFB', height: '100vh', display: 'flex', flexDirection: 'column', fontFamily: '"Inter", sans-serif', color: '#111827' }}>
      <UpgradeModal 
        isOpen={upgradeModal.show} 
        onClose={() => setUpgradeModal({ show: false, message: '' })} 
        message={upgradeModal.message} 
      />
      <ToastNotification toasts={toasts} removeToast={(id) => setToasts(prev => prev.filter(t => t.id !== id))} />

      {/* MODAL AI */}
      {showAIModal && (
        <AIGenerateModal
          isOpen={true}
          onClose={() => setShowAIModal(false)}
          onGenerate={handleAIGenerate}
          loading={isAILoading}
          currentType={testType}
        />
      )}

      {/* MODAL XÓA */}
      {showDeleteModal && <ConfirmDeleteModal onClose={() => setShowDeleteModal(false)} onConfirm={confirmDeleteQuestion} />}

      {/* HEADER */}
      <header style={{ height: '64px', backgroundColor: 'white', borderBottom: '1px solid #E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
          <div onClick={() => navigate('/business/dashboard')} style={{ width: '32px', height: '32px', cursor: 'pointer', color: '#6B7280', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><span className="material-symbols-outlined">arrow_back</span></div>
          <div style={{ height: '24px', width: '1px', backgroundColor: '#E5E7EB' }}></div>
          <input type="text" value={assessmentName} onChange={(e) => setAssessmentName(e.target.value)} className="title-input" style={{ border: 'none', fontSize: '18px', fontWeight: '700', outline: 'none', width: '100%', maxWidth: '400px', background: 'transparent' }} placeholder="Nhập tên bài kiểm tra..." />
          {isEditMode ? <span className="px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-700 border border-yellow-200">Chế độ sửa</span> : <span className="px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200">Bản nháp</span>}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button 
                    onClick={() => handleSave('DRAFT')} 
                    // ✅ Disable nút nếu đạt giới hạn và đang tạo mới
                    disabled={isSaving || (isLimitReached && !isEditMode)}
                    style={{ 
                        backgroundColor: 'white', border: '1px solid #D1D5DB', padding: '8px 16px', borderRadius: '8px', fontWeight: '600',
                        opacity: (isLimitReached && !isEditMode) ? 0.5 : 1, cursor: (isLimitReached && !isEditMode) ? 'not-allowed' : 'pointer'
                    }}
                >
                    Lưu nháp
                </button>
                <button 
                    onClick={() => handleSave('PUBLISHED')} 
                    disabled={isSaving || (isLimitReached && !isEditMode)}
                    style={{ 
                        backgroundColor: '#2563EB', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', fontWeight: '600',
                        opacity: (isLimitReached && !isEditMode) ? 0.5 : 1, cursor: (isLimitReached && !isEditMode) ? 'not-allowed' : 'pointer'
                    }}
                >
                    {isEditMode ? 'Cập nhật' : 'Đăng'}
                </button>
        </div>
      </header>
      {isLimitReached && !isEditMode && (
            <div style={{ backgroundColor: '#FEF2F2', borderBottom: '1px solid #FECACA', padding: '12px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#991B1B', fontSize: '14px' }}>
                    <span className="material-symbols-outlined">warning</span>
                    <span>
                        <strong>Đã đạt giới hạn!</strong> Gói {PLAN_FEATURES[userPlan].name} chỉ cho phép tạo {PLAN_FEATURES[userPlan].limit} bài test ({currentTestCount}/{PLAN_FEATURES[userPlan].limit}).
                    </span>
                </div>
                <button 
                    onClick={() => navigate('/business/upgrade-account')}
                    style={{ backgroundColor: '#DC2626', color: 'white', border: 'none', padding: '6px 16px', borderRadius: '6px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}
                >
                    Nâng cấp ngay
                </button>
            </div>
        )}

      {/* MAIN CONTAINER */}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

        {/* MAIN CONTENT */}
        <main id="main-content" style={{ flex: 1, overflowY: 'auto', padding: '32px', backgroundColor: '#FAFAFA' }}>
          <div style={{ maxWidth: '800px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '24px' }}>

            {/* Description Box */}
            <div style={{ backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '24px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '700', color: '#6B7280', textTransform: 'uppercase', marginBottom: '8px' }}>Mô tả bài kiểm tra</label>
              <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Nhập hướng dẫn..." style={{ width: '100%', minHeight: '80px', border: 'none', outline: 'none', fontSize: '15px', resize: 'none', color: '#374151' }} />
            </div>

            {/* MÀN HÌNH CHỌN LOẠI BÀI TEST */}
            {!testType && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                  {[{ id: 'mcq', label: 'Trắc nghiệm', icon: 'check_circle', desc: 'Chọn 1 đáp án đúng' }, { id: 'practical', label: 'Thực hành', icon: 'code', desc: 'Viết code / Tự luận' }, { id: 'iq', label: 'IQ / Logic', icon: 'psychology', desc: 'Tư duy logic' }].map(type => (
                    <div key={type.id} onClick={() => setTestType(type.id)} style={{ backgroundColor: 'white', padding: '24px', borderRadius: '12px', border: '1px solid #E5E7EB', cursor: 'pointer', textAlign: 'center', transition: 'all 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.borderColor = '#2563EB'} onMouseLeave={(e) => e.currentTarget.style.borderColor = '#E5E7EB'}>
                      <span className="material-symbols-outlined" style={{ fontSize: '32px', color: '#2563EB', marginBottom: '12px' }}>{type.icon}</span>
                      <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '4px' }}>{type.label}</h3>
                      <p style={{ fontSize: '13px', color: '#6B7280' }}>{type.desc}</p>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ flex: 1, height: '1px', backgroundColor: '#E5E7EB' }}></div>
                  <span style={{ fontSize: '14px', color: '#9CA3AF', fontWeight: '500' }}>HOẶC</span>
                  <div style={{ flex: 1, height: '1px', backgroundColor: '#E5E7EB' }}></div>
                </div>
                <div 
                  onClick={handleAIButtonClick} // <--- Thay setShowAIModal(true) bằng hàm check quyền
                  style={{ background: 'linear-gradient(to right, #F3E8FF, #DBEAFE)', border: '1px dashed #8B5CF6', borderRadius: '12px', padding: '32px', textAlign: 'center', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', transition: 'all 0.2s', position: 'relative' }} 
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.01)'} 
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  {!PLAN_FEATURES[userPlan].ai && (
                      <div style={{position:'absolute', right:0, top:0, background:'#F59E0B', color:'white', fontSize:'10px', padding:'2px 8px', fontWeight:'bold', borderBottomLeftRadius:'8px'}}>PRO ONLY</div>
                  )}
                  <div style={{ width: '56px', height: '56px', background: 'white', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                    <span className="material-symbols-outlined" style={{ fontSize: '32px', background: 'linear-gradient(to right, #8B5CF6, #2563EB)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>auto_awesome</span>
                  </div>

                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#111827' }}>
                        Tạo đề thi tự động bằng AI {!PLAN_FEATURES[userPlan].ai && '🔒'}
                    </h3>
                    <p style={{ fontSize: '14px', color: '#6B7280', marginTop: '4px' }}>Nhập chủ đề, SkillMatch AI sẽ sinh câu hỏi và đáp án cho bạn trong tích tắc.</p>
                  </div>
                </div>
              </div>
            )}
            

            {/* MÀN HÌNH SOẠN THẢO */}
            {testType && (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>Loại bài: <span style={{ color: '#2563EB' }}>{testType.toUpperCase()}</span></span>
                  <button onClick={() => { setTestType(null); setParsedQuestions([]); setUploadedFile(null); }} style={{ fontSize: '13px', color: '#EF4444', border: 'none', background: 'none', cursor: 'pointer' }}>Chọn lại</button>
                </div>

                <div style={{ display: 'flex', gap: '16px' }}>
                  <div onClick={triggerFileInput} style={{ flex: 1, backgroundColor: 'white', border: '1px dashed #D1D5DB', borderRadius: '12px', padding: '16px', textAlign: 'center', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <input type="file" ref={fileInputRef} onChange={handleFileSelect} style={{ display: 'none' }} accept=".txt" />
                    <span className="material-symbols-outlined text-gray-400">upload_file</span>
                    <span style={{ fontSize: '14px', fontWeight: '500', color: '#4B5563' }}>Thêm từ file .txt</span>
                  </div>
                  <div 
                    onClick={handleAIButtonClick} // <--- Thay setShowAIModal(true)
                    style={{ flex: 1, backgroundColor: '#F3E8FF', border: '1px dashed #C4B5FD', borderRadius: '12px', padding: '16px', textAlign: 'center', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', position: 'relative', overflow: 'hidden' }}
                  >
                    {!PLAN_FEATURES[userPlan].ai && (
                        <div style={{position:'absolute', right:0, top:0, background:'#F59E0B', color:'white', fontSize:'10px', padding:'2px 8px', fontWeight:'bold', borderBottomLeftRadius:'8px'}}>PRO</div>
                    )}
                    <span className="material-symbols-outlined text-purple-600">auto_awesome</span>
                    <span style={{ fontSize: '14px', fontWeight: '500', color: '#6B21A8' }}>
                        Thêm câu hỏi AI {!PLAN_FEATURES[userPlan].ai && '🔒'}
                    </span>
                  </div>
                </div>

                {/* Question List */}
                {parsedQuestions.map((q, idx) => (
                  <div key={idx} draggable onDragStart={(e) => handleDragStart(e, idx)} onDragEnter={(e) => handleDragEnter(e, idx)} onDragEnd={handleDragEnd} onDragOver={(e) => e.preventDefault()} className={`group bg-white border rounded-lg shadow-sm hover:shadow-md transition-all relative ${draggedItemIndex === idx ? 'border-[#5048e5] opacity-50 bg-blue-50' : 'border-gray-200'}`}>
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#5048e5] rounded-l-lg opacity-0 group-hover:opacity-100 transition-opacity"></div>
                    <div className="flex items-start p-6 gap-4">
                      <div className="pt-2 text-gray-300 opacity-0 group-hover:opacity-100 hover:text-gray-600 transition-opacity cursor-grab active:cursor-grabbing"><span className="material-symbols-outlined text-[20px]">drag_indicator</span></div>
                      <div className="flex-1 flex flex-col gap-4">

                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-md text-sm font-medium text-[#111827]">
                              <span className="material-symbols-outlined text-[18px] text-[#5048e5]">
                                {q.type === 'code' ? 'code' : (q.type === 'essay' ? 'edit_note' : 'check_circle')}
                              </span>
                              <span>
                                {q.type === 'code' ? 'Code (Thực hành)' : (q.type === 'essay' ? 'Tự luận' : 'Trắc nghiệm')}
                              </span>
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="text-xs font-bold text-gray-400 uppercase tracking-wide">Skill:</span>
                              <input type="text" value={q.skill || ''} onChange={(e) => updateQuestion(idx, 'skill', e.target.value)} placeholder="VD: React..." className="border-none bg-blue-50 hover:bg-blue-100 focus:bg-white focus:ring-1 focus:ring-blue-500 rounded px-2 py-1 text-xs font-semibold text-blue-700 w-32 transition-colors placeholder-blue-300" />
                            </div>
                          </div>

                          <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button onClick={() => duplicateQuestion(idx)} className="text-gray-400 hover:text-blue-500 p-1 rounded hover:bg-gray-100" title="Nhân bản"><span className="material-symbols-outlined text-[20px]">content_copy</span></button>
                            <button onClick={() => requestDeleteQuestion(idx)} className="text-gray-400 hover:text-red-500 p-1 rounded hover:bg-gray-100" title="Xóa câu hỏi"><span className="material-symbols-outlined text-[20px]">delete</span></button>
                          </div>
                        </div>

                        {/* ✅ THAY THẾ PHẦN CŨ BẰNG HÀM RENDER CHUẨN ĐỂ HIỂN THỊ ĐÚNG LOẠI CÂU HỎI AI */}
                        {renderQuestionContent(q, idx)}

                      </div>
                    </div>
                  </div>
                ))}

                <div onClick={() => addManualQuestion(testType === 'practical' ? 'code' : 'mcq')} style={{
                  border: '2px dashed #E5E7EB', borderRadius: '12px', padding: '16px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                  cursor: 'pointer', transition: 'all 0.2s', color: '#6B7280'
                }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#2563EB'; e.currentTarget.style.color = '#2563EB'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#E5E7EB'; e.currentTarget.style.color = '#6B7280'; }}
                >
                  <span className="material-symbols-outlined">add_circle</span>
                  <span style={{ fontSize: '14px', fontWeight: '600' }}>Thêm câu hỏi mới thủ công</span>
                </div>
              </>
            )}
            

          </div>
        </main>

        {/* SIDEBAR */}
        <aside style={{ width: '320px', backgroundColor: 'white', borderLeft: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '20px', borderBottom: '1px solid #E5E7EB', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#111827' }}>Cấu hình</h3>
          </div>
          <div style={{ padding: '20px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <p style={{ fontSize: '12px', fontWeight: '700', color: '#9CA3AF', textTransform: 'uppercase' }}>Loại bài kiểm tra</p>
              <div
                onClick={() => setIsPublic(false)}
                style={{
                  padding: '12px', borderRadius: '8px', cursor: 'pointer',
                  border: !isPublic ? '2px solid #2563EB' : '1px solid #E5E7EB',
                  backgroundColor: !isPublic ? '#EFF6FF' : 'white',
                  transition: 'all 0.2s', display: 'flex', gap: '10px', alignItems: 'flex-start'
                }}
              >
                <span className="material-symbols-outlined" style={{ color: !isPublic ? '#2563EB' : '#9CA3AF', fontSize: '20px' }}>lock</span>
                <div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: !isPublic ? '#1E40AF' : '#374151' }}>Riêng tư (Tuyển dụng)</div>
                  <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '2px', lineHeight: '1.4' }}>Chỉ dành cho ứng viên nộp hồ sơ vào Job. Không hiện ra ngoài.</div>
                </div>
                {!isPublic && <span className="material-symbols-outlined" style={{ color: '#2563EB', fontSize: '18px', marginLeft: 'auto' }}>check_circle</span>}
              </div>

              <div
                onClick={() => setIsPublic(true)}
                style={{
                  padding: '12px', borderRadius: '8px', cursor: 'pointer',
                  border: isPublic ? '2px solid #2563EB' : '1px solid #E5E7EB',
                  backgroundColor: isPublic ? '#EFF6FF' : 'white',
                  transition: 'all 0.2s', display: 'flex', gap: '10px', alignItems: 'flex-start'
                }}
              >
                <span className="material-symbols-outlined" style={{ color: isPublic ? '#2563EB' : '#9CA3AF', fontSize: '20px' }}>public</span>
                <div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: isPublic ? '#1E40AF' : '#374151' }}>Công khai (Luyện tập)</div>
                  <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '2px', lineHeight: '1.4' }}>Hiển thị trên kho đề thi chung cho mọi người làm thử.</div>
                </div>
                {isPublic && <span className="material-symbols-outlined" style={{ color: '#2563EB', fontSize: '18px', marginLeft: 'auto' }}>check_circle</span>}
              </div>
            </div>

            <hr style={{ border: 'none', borderTop: '1px solid #F3F4F6' }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <p style={{ fontSize: '12px', fontWeight: '700', color: '#9CA3AF', textTransform: 'uppercase' }}>Chung</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div><div style={{ fontSize: '14px', fontWeight: '500', color: '#111827' }}>Thời gian làm bài</div><div style={{ fontSize: '12px', color: '#6B7280' }}>Tính bằng phút</div></div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', backgroundColor: '#F3F4F6', padding: '4px 8px', borderRadius: '6px', border: '1px solid #E5E7EB' }}><input type="number" value={timeLimit} onChange={(e) => setTimeLimit(e.target.value)} style={{ width: '40px', background: 'transparent', border: 'none', outline: 'none', textAlign: 'right', fontWeight: '600', fontSize: '14px' }} /><span style={{ fontSize: '12px', color: '#6B7280' }}>phút</span></div>
              </div>

              {isPublic && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', animation: 'fadeIn 0.3s ease' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Thời gian mở đề (Start)</label>
                    <input
                      type="datetime-local"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      onClick={(e) => e.target.showPicker && e.target.showPicker()}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '13px', color: '#111827', outline: 'none', backgroundColor: '#FAFAFA', cursor: 'pointer' }}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <label style={{ fontSize: '13px', fontWeight: '500', color: '#374151' }}>Thời gian đóng đề (End)</label>
                    <input
                      type="datetime-local"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      onClick={(e) => e.target.showPicker && e.target.showPicker()}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '13px', color: '#111827', outline: 'none', backgroundColor: '#FAFAFA', cursor: 'pointer' }}
                    />
                  </div>
                </div>
              )}

            </div>
            <hr style={{ border: 'none', borderTop: '1px solid #F3F4F6' }} />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <p style={{ fontSize: '12px', fontWeight: '700', color: '#9CA3AF', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '6px' }}><span className="material-symbols-outlined" style={{ fontSize: '16px' }}>verified_user</span> Giám sát & Bảo mật</p>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div><div style={{ fontSize: '14px', fontWeight: '500', color: '#111827' }}>Chống gian lận</div><div style={{ fontSize: '12px', color: '#6B7280' }}>Kích hoạt hệ thống</div></div>
                <ToggleSwitch checked={securitySettings.enableAI} onChange={() => handleSecurityChange('enableAI')} />
              </div>

              {/* ✅ FIX: Bao bọc các nút con vào div này để mờ đi khi nút tổng tắt */}
              <div style={{ 
                  opacity: securitySettings.enableAI ? 1 : 0.5, // Mờ đi nếu tắt tổng
                  pointerEvents: securitySettings.enableAI ? 'auto' : 'none', // Không cho click nếu tắt tổng
                  transition: 'opacity 0.2s',
                  display: 'flex', flexDirection: 'column', gap: '16px' // Khoảng cách giữa các nút con
              }}>
                  
                  {/* 1. WEBCAM */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                     <LockedToggle 
                            label="Webcam"
                            subLabel="Chụp ảnh ngẫu nhiên"
                            checked={securitySettings.enableWebcam}
                            // Gói PRO không có webcam -> isLocked = true
                            isLocked={!PLAN_FEATURES[userPlan].webcam}
                            onTriggerUpgrade={() => triggerUpgrade("Webcam", "ENTERPRISE")}
                            onChange={() => setSecuritySettings(p => ({...p, enableWebcam: !p.enableWebcam}))}
                      />
                    
                    {securitySettings.enableWebcam && securitySettings.enableAI && (
                      <div style={{ padding: '8px 12px', background: '#F9FAFB', borderRadius: '8px', border: '1px solid #E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: '12px' }}>
                        <span style={{ fontSize: '13px', color: '#4B5563' }}>Chụp mỗi (phút):</span>
                        <input
                          type="number" min="1"
                          value={securitySettings.webcamInterval}
                          onChange={(e) => handleSecurityChange('webcamInterval', e.target.value)}
                          style={{ width: '50px', padding: '4px', borderRadius: '4px', border: '1px solid #D1D5DB', fontSize: '13px', textAlign: 'center' }}
                        />
                      </div>
                    )}
                  </div>

                 {/* 2. KHÓA TRÌNH DUYỆT */}
                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <LockedToggle
                            label="Khóa trình duyệt"
                            subLabel="Chặn mở tab khác"
                            checked={securitySettings.lockBrowser}
                            // Gói PRO có lockBrowser -> isLocked = false (Sáng)
                            // Nhưng vì nằm trong div cha bị mờ (nếu tắt tổng), nên nó cũng sẽ mờ theo
                            isLocked={!PLAN_FEATURES[userPlan].lockBrowser}
                            onTriggerUpgrade={() => triggerUpgrade("Khóa trình duyệt", "PROFESSIONAL")}
                            onChange={() => setSecuritySettings(p => ({...p, lockBrowser: !p.lockBrowser}))}
                        />
                    {securitySettings.lockBrowser && securitySettings.enableAI && (
                      <div style={{ padding: '8px 12px', background: '#FEF2F2', borderRadius: '8px', border: '1px solid #FECACA', display: 'flex', flexDirection: 'column', gap: '4px', marginLeft: '12px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span style={{ fontSize: '13px', color: '#991B1B', fontWeight: '500' }}>Giới hạn vi phạm:</span>
                          <input
                            type="number" min="1" max="5"
                            value={securitySettings.maxViolationLimit}
                            onChange={(e) => {
                              let val = e.target.value;
                              if (val === '') handleSecurityChange('maxViolationLimit', '');
                              else {
                                let num = parseInt(val);
                                if (num > 5) num = 5; if (num < 1) num = 1;
                                handleSecurityChange('maxViolationLimit', num);
                              }
                            }}
                            style={{ width: '50px', padding: '4px', borderRadius: '4px', border: '1px solid #FCA5A5', fontSize: '13px', textAlign: 'center', color: '#7F1D1D', fontWeight: 'bold' }}
                          />
                        </div>
                        <span style={{ fontSize: '11px', color: '#B91C1C' }}>*Tự động nộp bài khi quá số lần này (Max: 5).</span>
                      </div>
                    )}
                    </div>
              </div>

            </div>
            <div style={{ marginTop: 'auto', backgroundColor: '#EFF6FF', padding: '16px', borderRadius: '8px', border: '1px solid #DBEAFE', display: 'flex', gap: '12px' }}><span className="material-symbols-outlined" style={{ fontSize: '20px', color: '#2563EB' }}>info</span><div><p style={{ fontSize: '12px', fontWeight: '700', color: '#1E40AF', marginBottom: '4px' }}>Mẹo hay</p><p style={{ fontSize: '12px', color: '#2563EB', lineHeight: '1.4' }}>Sử dụng file .txt chuẩn format để hệ thống tự động nhận diện đáp án đúng.</p></div></div>
          </div>
        </aside>
      </div>

      {/* CSS CHO THANH SLIDER ĐẸP */}
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #E5E7EB; border-radius: 10px; }
        ::-webkit-scrollbar-thumb:hover { background: #D1D5DB; }
        .title-input { border: 1px solid transparent; outline: none !important; box-shadow: none !important; padding: 4px 8px; border-radius: 4px; transition: all 0.2s; }
        .title-input:hover { border-color: #E5E7EB; background-color: #F9FAFB; }
        .title-input:focus { border-color: #D1D5DB; background-color: #FFFFFF; }

        /* Custom Slider Style */
        .custom-range {
            -webkit-appearance: none;
            width: 100%;
            height: 6px;
            background: #E5E7EB;
            border-radius: 8px;
            outline: none;
        }
        .custom-range::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #2563EB;
            cursor: pointer;
            transition: background .15s ease-in-out;
            box-shadow: 0 0 0 3px white, 0 0 0 4px #2563EB;
        }
        .custom-range::-webkit-slider-thumb:hover {
            background: #1D4ED8;
        }
        .custom-range::-moz-range-thumb {
            width: 20px;
            height: 20px;
            border: 0;
            border-radius: 50%;
            background: #2563EB;
            cursor: pointer;
            transition: background .15s ease-in-out;
            box-shadow: 0 0 0 3px white, 0 0 0 4px #2563EB;
        }
      `}</style>
    </div>
  );
}